<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('listing.batchComponents.ChangeOwnerComponent.change_owner')"
        class="change-owner-component"
        @closed="close"
    >
        <template slot="default">
            <div class="dialog__default">
                <el-select
                    v-model="staff"
                    filterable
                    remote
                    :placeholder="$t.__('common.actions.search')"
                    :remoteMethod="autoCompleteStaff"
                    :loading="loading"
                    class="wp-10"
                >
                    <el-option
                        v-for="item in staffs"
                        :key="item.id"
                        :label="item.fullName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('common.actions.confirm')"
                    type="primary"
                    class="ml-2"
                    @click="save"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
            staff: '',
            staffs: [],
        };
    },
    created() {
        this.initStaffs();
    },
    methods: {
        initStaffs() {
            this.loading = true;
            this.$ajax.get(
                `/rest/staffs/list`,
                {},
                (response) => {
                    this.staffs = response;
                    this.loading = false;
                },
                () => {
                    Push.error(this.$l10n.__('Problème lors de la récupération des données'));
                    this.loading = false;
                },
            );
        },

        autoCompleteStaff: _.debounce(function (query) {
            if (query !== '') {
                this.loading = true;
                this.$ajax.get(
                    `/rest/staffs/autocomplete`,
                    { q: query },
                    (response) => {
                        this.staffs = response;
                        this.loading = false;
                    },
                    () => {
                        Push.error(this.$l10n.__('Problème lors de la récupération des données'));
                        this.loading = false;
                    },
                );
            } else {
                this.initStaffs();
            }
        }),

        save() {
            if (this.staff !== '') {
                this.loading = true;
                this.$ajax.post(
                    `/recurrings/owner/update/` + this.staff,
                    {},
                    { recIds: this.rows },
                    () => {
                        Push.success(this.$l10n.__('Le créateur a bien été mis à jour'));
                        this.close();
                        this.$trigger('listing:refresh');
                    },
                    () => {
                        this.close();
                        Push.error(this.$l10n.__('Une erreur est survenue'));
                    },
                );
            } else {
                Push.error(this.$l10n.__('Veuillez choisir un collaborateur'));
            }
        },
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.change-owner-component {
    .dialog {
        &__header {
            display: flex;
            justify-content: space-between;
            padding: var(--spacing-4) var(--spacing-5);

            &--title {
                display: flex;
                flex-direction: column;
            }

            &--close {
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
            }
        }

        &__default {
            padding-bottom: var(--spacing-4);
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 var(--spacing-5) var(--spacing-4);
        }
    }
}
</style>
